import { createContext } from "react";

export const VersionContext = createContext();
